import React from 'react';
import TextInput from 'src/ui/library/TextInput';
import TextArea from 'src/ui/library/TextArea';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

const renderCustomTextControl = props => {
  let { multiline, description } = props;

  if (multiline && multiline === true) {
    return <TextArea {...props} />;
  }

  if (description) {
    return (
      <React.Fragment>
        <span component="legend" className="control-label">
          {description}
        </span>
        <TextInput {...props} />
      </React.Fragment>
    );
  }

  return <TextInput {...props} />;
};

const CustomTextControl = props => {
  const { helpText, headerText, ...otherProps } = props;

  let component = renderCustomTextControl(otherProps);

  if (helpText) {
    component = (
      <InfoTooltip
        toolTipText={helpText}
        labelText={component}
        className="custom-text-tooltip"
        labelClassName="custom-text-tooltip-label"
      />
    );
  }

  return component;
};

export default WithHeader(CustomTextControl);
